import React from "react";
import { ReactComponent as Box1 } from "../../assets/images/box1.svg";
import { ReactComponent as Box2 } from "../../assets/images/box2.svg";
import { ReactComponent as Box3 } from "../../assets/images/box3.svg";

const TrackingProgress = ({ progress }) => {
  const prog_color = "#4DAF7C";
  //console.log(progress);

  if (!progress) {
    return <></>;
  }

  return (
    <div style={{ display: "flex", marginBottom: "20px" }}>
      <div className="progress-container">
        <div className="progress-item">
          <Box1 fill={progress >= 10 ? prog_color : "#C4B000"} height="48px" />
          <p style={{ color: progress >= 10 ? prog_color : "#C4B000" }}>
            მიღებულია
          </p>
        </div>

        <div
          className="progress-line"
          style={{
            backgroundColor: progress >= 50 ? prog_color : "#ffffff99",
          }}
        ></div>

        <div className="progress-item">
          <Box2 fill={progress >= 50 ? prog_color : "black"} height="48px" />
          <p style={{ color: progress >= 50 ? prog_color : "black" }}>გზაშია</p>
        </div>
        <div
          className="progress-line"
          style={{
            backgroundColor: progress >= 100 ? prog_color : "#ffffff99",
          }}
        ></div>
        <div className="progress-item">
          <Box3 fill={progress >= 100 ? prog_color : "black"} height="48px" />
          <p style={{ color: progress >= 100 ? prog_color : "black" }}>
            ჩაბარდა
          </p>
        </div>
      </div>
    </div>
  );
};

export default TrackingProgress;
